var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistoryIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon history-icon",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10a.75.75 0 011.5 0 8.5 8.5 0 102.691-6.206l2.471-.289c.377-.044.722.2.814.557l.019.1a.751.751 0 01-.557.814l-.1.019-4.25.5a.75.75 0 01-.831-.643L1.75 4.75v-4A.75.75 0 013.243.648L3.25.75l-.001 1.873A9.967 9.967 0 0110 0zm0 4a.75.75 0 01.743.648l.007.102.001 4.939 2.03 2.03c.266.267.29.684.072.977l-.073.084a.75.75 0 01-.976.073l-.084-.073-2.25-2.25a.74.74 0 01-.21-.412L9.25 10V4.75A.75.75 0 0110 4z"
  })));
}

export default SvgHistoryIconSv;